import { useTranslation } from 'react-i18next';

import RenderCard from './RenderCard';

const DataCenter = ({ dataCenter }: { dataCenter: string }) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  return (
    <RenderCard
      title={t('dataCenter.title')}
      value={dataCenter}
      dataTestId="data-center-card"
    />
  );
};

export default DataCenter;
